import { DYNAMICFORMS_URL } from "utils/constants";
import { ENDPOINTSDYNAMICFORMS } from "utils/endpoints";
import { http } from "utils/http";

export const  postGridForm =(  (data,method) =>   http({
   baseURL:DYNAMICFORMS_URL,
   url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormDataGrid.browse,
   method,
   data:data
})

.then((respons) => (respons.data))
.catch((err) => {

    return Promise.reject( err);
})
)
